import { normalizeRepoPathRelativeToWorkspaceRoot } from '../repo/normalize-repo-path-relative-to-workspace-root.js';

/** File path relative to a repo root, derived from workspace-relative paths. */
export function filePathRelativeToRepoRootFromWorkspace(
  filePathRelativeToWorkspaceRoot: string,
  repoPathRelativeToWorkspaceRoot: string,
): string {
  const repoPath = normalizeRepoPathRelativeToWorkspaceRoot(repoPathRelativeToWorkspaceRoot);
  if (repoPath === '.') return filePathRelativeToWorkspaceRoot;
  if (filePathRelativeToWorkspaceRoot.startsWith(`${repoPath}/`)) {
    return filePathRelativeToWorkspaceRoot.slice(repoPath.length + 1);
  }
  return filePathRelativeToWorkspaceRoot;
}
